function h(t, o) {
  return Math.sqrt(Math.pow(o[0] - t[0], 2) + Math.pow(o[1] - t[1], 2) + Math.pow(o[2] - t[2], 2));
}
export {
  h as distance3d
};
//# sourceMappingURL=index5.js.map
